import { IHooksUseRequestSetCoinsToUserParams } from '@/interfaces';
import { useMutation } from '@tanstack/react-query';
import { handleApiResponse } from '@/functions';
import { useInvalidateQueries } from '@/hooks';
import { broadcastService } from '@/services';
import { apiClient } from '@/components/api';
import routes from '@/lib/routes';

type TParams = {
  disableInvalidateQueries?: boolean;
};
type TDataVariables = IHooksUseRequestSetCoinsToUserParams;
type TResponseData = void;

export const useRequestSetCoinsToUser = (params?: TParams) => {

  const { invalidate } = useInvalidateQueries();
  const { isPending, error, mutateAsync } = useMutation({
    mutationKey: [routes.api.users.base, 'setCoins'],
    mutationFn: ({ userId, ...data }: TDataVariables) =>
      apiClient
        .put<TResponseData>(routes.api.users.setCoins(userId), data)
        .then(handleApiResponse)
        .then(() => broadcastService.events.publish({ type: 'userCoinsEdited', data: ({ userId, ...data }) })),
    onSuccess: () => (
      !params?.disableInvalidateQueries &&
      Promise
        .all([
          invalidate(routes.api.subAccounts),
          invalidate(routes.api.searchUser),
          invalidate(routes.api.users.base)
        ])
    )
  });

  const triggerSetCoinsToUser = (data: TDataVariables) =>
    mutateAsync(data);

  return ({
    isLoadingSetCoinsToUser: isPending,
    triggerSetCoinsToUser,
    error
  });

};  
